import { render, staticRenderFns } from "./emailSpamIcon.vue?vue&type=template&id=649e96a8"
import script from "./emailSpamIcon.vue?vue&type=script&lang=js"
export * from "./emailSpamIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports